<template>
    <v-app app class="full-page-primary">
        <v-container class="fill-height text-center align justify" fluid style="width: 100%; height: 100%;">
            <v-row class="fill-height ml-0" align="center" justify="center" align-content="center">
              <v-col cols="12" lg="3" sm="12">
                <div>
                  <div class="text-center mb-4">
                      <img src="logo-no-adp.png" />
                  </div>
                  <v-alert v-if="isErrorVisible" type="error">{{errorMessage}}</v-alert>
                  <v-form @submit.prevent="" v-model="isFormValid" ref="form">
                      <v-text-field v-if="isLoginWithEmail" type="email" label="Email" v-model="form.email" :rules="emailRules" solo :disabled="submitting" autocomplete="username" />
                      <v-text-field v-if="isPWlogin" type="password" label="Password" v-model="form.password" solo :disabled="submitting" autocomplete="current-password"/>
                  
                      <v-btn v-if="isPWlogin" type="submit" class="mb-3" color="secondary" block large @click="submit()" :loading="unpwLoading" :disabled="!isFormValid || submitting">LOGIN</v-btn>
                      
                      <v-btn v-if="!isPWlogin" class="mb-3" color="secondary" block large @click="clickLoginEmailButton" :loading="unpwLoading" :disabled="!isFormValid || submitting">{{ isLoginWithEmail ? 'LOGIN WITH PASSWORD' : 'LOGIN WITH EMAIL' }}</v-btn>

                      <v-btn v-if="isPWlogin" class="mb-3" color="warning" block large @click="isPWlogin = false; isLoginWithEmail = false; isErrorVisible = false;">CANCEL</v-btn>

                      <v-btn v-if="!isPWlogin && ! isLoginWithEmail && showLoginWithGoogle" class="google mb-3" block large @click="googleLoading = true" :to="{ name: 'loginGoogle', params: { noWait: true } }" :disabled="submitting" :loading="googleLoading">
                          <v-avatar size="18" style="margin-right: 5px; margin-bottom: 5px;">
                          <img class="icon pr-1" src="google.svg" />
                          </v-avatar>
                          LOGIN WITH GOOGLE
                      </v-btn>
                      <v-btn v-if="!isPWlogin && ! isLoginWithEmail && showLoginWithApple" class="apple mb-3" color="black" block large :dark="true" @click="googleLoading = true" :to="{ name: 'loginApple', params: { noWait: true } }" :disabled="submitting" :loading="appleLoading">
                          <v-avatar size="18" style="margin-right: 5px; margin-bottom: 5px;">
                          <img class="icon pr-1" src="apple_white.svg" />
                          </v-avatar>
                          Sign in with Apple
                      </v-btn>
                      <v-btn v-if="!isPWlogin && ! isLoginWithEmail" color="indigo" class="mb-3" :dark="!submitting" block large :to="{ name: 'Register' }" :disabled="submitting">REGISTER WITH EMAIL</v-btn>
                      <v-btn v-if="!isPWlogin && ! isLoginWithEmail" block large :to="{ name: 'password-reset' }" :disabled="submitting">PASSWORD RECOVERY</v-btn>
                  </v-form>
              </div>
              </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'login',
  data() {
    return {
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      isErrorVisible: false,
      errorMessage: '',
      isFormValid: false,
      googleLoading: false,
      appleLoading: false,
      isPWlogin: false,
      isLoginWithEmail: false,
      unpwLoading: false,
      submitting: false,
      showLoginWithApple: false,
      showLoginWithGoogle: false,
      dictionary: {
        attributes: {
          email: 'e-mail address'
        }
      },
      form: {
        email: '',
        password: '',
        remember: null
      }
    }
  },

  computed: {

  },

  methods: {
    showError(msg){
      this.errorMessage = msg
      this.isErrorVisible = true
    },
    hideError(){
      this.errorMessage = ''
      this.isErrorVisible = false
    },
    clickLoginEmailButton(){
      this.isLoginWithEmail = true
      this.isPWlogin = true
    },
    signInGoogle () {
      // this.submitting = true
      // this.googleLoading = true
      // this.$auth
      //   .signInWithGoogle()
      //   .then(result => {
      //     // This gives you the Google's Access Token. You can use it to access the Google API.
      //     console.log("SIGNINGOOGLE Token : " + result.credential.accessToken)
      //     // The signed-in user info.
      //     console.log("SIGNINGOOGLE User Email : " + result.user.email)
      //     this.submitting = false;
      //     this.loginRedirect()
      //   })
      //   .catch(error => {
      //     this.submitting = false
      //     this.googleLoading = false
      //     this.clicked = ''
      //     this.form.password = ''
      //     this.SHOW_SNACKBAR(error.message)
      //   });
    },
    async submit() {
      if( this.$refs.form.validate() ){
        this.submitting = true
        this.unpwLoading = true
        this.hideError()

        console.log( 'Doing Login' )
        try {
            const user = await this.$firebase.auth().signInWithEmailAndPassword( this.form.email, this.form.password )
            console.log( 'loginWithEmailAndPassword', user )
            this.submitting = false
            this.loginRedirect()
        } catch( e ){
            console.log( e )
            this.submitting = false
            this.unpwLoading = false
            this.form.password = ''
            this.showError( e.message )
        }
      }
    },
    async loginViaEmailLink(){

      try {
        await this.$auth.sendLoginLinkEmail( this.form.email )
        // this.SHOW_SNACKBAR('Please check your email for the login link')
      } catch( e ){
        // this.SHOW_SNACKBAR(e.message)
      }

    },
    loginRedirect(){
      if (this.$route.query.redirect) {
        this.$router.replace({ path: this.$route.query.redirect })
      } else {
        this.$router.replace({ name: 'home' })
      }
    }
  },
  mounted() {
    console.log( 'Login mounted' )
  }
}
</script>


<style>
.v-application {
    background-color: #5555a5 !important;
}
</style>